<app-feedback-with-go-home
  iconType="warning"
  title="404 Page not found"
  [textLines]="[
    'The page you are looking for doesn’t exist, or another error occurred.'
  ]"
></app-feedback-with-go-home>
